import { h } from 'preact';

export const Loading = () => (
    <span class="loading-spinner" />
);